(function () {
  document.documentElement.classList.add('js');

  var storageKey = 'sattbar:last-form-submission';

  function getFieldValue(form, name) {
    var field = form.querySelector('[name="' + name + '"]');
    return field ? field.value.trim() : '';
  }

  function saveSubmission(form) {
    var payload = {
      name: getFieldValue(form, 'contact[name]'),
      email: getFieldValue(form, 'contact[email]'),
      message: getFieldValue(form, 'contact[body]'),
      tags: getFieldValue(form, 'contact[tags]'),
      submittedAt: Date.now()
    };

    if (!payload.email && !payload.message && !payload.name) {
      return;
    }

    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(payload));
    } catch (error) {
      return;
    }
  }

  function hasSuccessfulFormPost() {
    var params = new URLSearchParams(window.location.search);

    return (
      params.get('contact_posted') === 'true' ||
      params.get('customer_posted') === 'true' ||
      document.querySelector('.form-success') !== null
    );
  }

  function getSavedSubmission() {
    var raw;

    try {
      raw = window.sessionStorage.getItem(storageKey);
    } catch (error) {
      return null;
    }

    if (!raw) {
      return null;
    }

    try {
      var payload = JSON.parse(raw);
      var isFresh = payload.submittedAt && Date.now() - payload.submittedAt < 10 * 60 * 1000;
      return isFresh ? payload : null;
    } catch (error) {
      return null;
    }
  }

  function addDetail(list, label, value) {
    if (!value) {
      return;
    }

    var row = document.createElement('div');
    var term = document.createElement('dt');
    var description = document.createElement('dd');

    term.textContent = label;
    description.textContent = value;
    row.appendChild(term);
    row.appendChild(description);
    list.appendChild(row);
  }

  function openSuccessOverlay(payload) {
    var overlay = document.querySelector('[data-submission-success]');
    var panel = overlay ? overlay.querySelector('.submission-success__panel') : null;
    var details = overlay ? overlay.querySelector('[data-submission-success-details]') : null;

    if (!overlay || !panel || !details) {
      return;
    }

    details.textContent = '';
    addDetail(details, 'Name', payload.name);
    addDetail(details, 'E-Mail', payload.email);
    addDetail(details, 'Nachricht', payload.message);

    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    panel.focus();
  }

  function closeSuccessOverlay() {
    var overlay = document.querySelector('[data-submission-success]');

    if (!overlay) {
      return;
    }

    overlay.hidden = true;
    document.body.style.overflow = '';

    try {
      window.sessionStorage.removeItem(storageKey);
    } catch (error) {
      // Continue to the homepage even if storage cleanup is blocked.
    }

    window.location.assign(overlay.dataset.homeUrl || '/');
  }

  function captureContactEmailForCustomerList(contactForm) {
    var captureForm = document.querySelector('.contact-customer-capture');

    if (!captureForm) {
      return Promise.resolve();
    }

    var email = getFieldValue(contactForm, 'contact[email]');
    var name = getFieldValue(contactForm, 'contact[name]');

    if (!email) {
      return Promise.resolve();
    }

    var emailInput = captureForm.querySelector('[name="contact[email]"]');
    var firstNameInput = captureForm.querySelector('[name="contact[first_name]"]');

    if (emailInput) {
      emailInput.value = email;
    }

    if (firstNameInput) {
      firstNameInput.value = name;
    }

    try {
      return window.fetch(captureForm.action, {
        method: 'POST',
        body: new FormData(captureForm),
        credentials: 'same-origin',
        keepalive: true
      }).catch(function () {});
    } catch (error) {
      return Promise.resolve();
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (!form.matches('.contact-form, .waitlist-form')) {
      return;
    }

    saveSubmission(form);

    if (form.matches('.contact-form') && !form.dataset.customerCaptureStarted) {
      event.preventDefault();
      form.dataset.customerCaptureStarted = 'true';

      captureContactEmailForCustomerList(form).finally(function () {
        form.submit();
      });
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-submission-success-close]')) {
      closeSuccessOverlay();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeSuccessOverlay();
    }
  });

  window.addEventListener('load', function () {
    if (!hasSuccessfulFormPost()) {
      return;
    }

    var payload = getSavedSubmission();

    if (payload) {
      openSuccessOverlay(payload);
    }
  });
})();
